import { LS_KEYS } from "utils/constants/localStorageKeys";

// Neutral fallback used across the Manage Users flow when the active outlet
// name is missing (matches the "Outlet" fallback used elsewhere in the app).
export const OUTLET_NAME_FALLBACK = "Outlet";

export const getSelectedOutletId = () =>
  window.localStorage.getItem(LS_KEYS.OUTLET_ID) || "";

export const getSelectedOutletName = () =>
  window.localStorage.getItem(LS_KEYS.OUTLET_NAME) || OUTLET_NAME_FALLBACK;

export const setSelectedOutlet = ({ outlet_id, outlet_name }) => {
  window.localStorage.setItem(LS_KEYS.OUTLET_ID, outlet_id);
  window.localStorage.setItem(LS_KEYS.OUTLET_NAME, outlet_name);
};
